<template>
    <table
        border="1"
        cellpadding="0"
        cellspacing="0"
        class="w-full max-w-[915px] table-fixed"
        v-if="persons.length"
    >
        <thead>
        <tr valign="top">
            <!-- Clickable headers for sorting with a chevron -->
            <th class="text-[20px] p-2 text-left cursor-pointer" @click="sortBy('name')">
                <span :class="[ { 'underline': sortKey === 'name' }]">Namn</span>
                <SortChevron :sort-key="'name'" :sort-order="sortOrder" :current-sort-key="sortKey" />
            </th>
            <th class="text-[20px] p-2 text-left cursor-pointer" @click="sortBy('role')">
                <span :class="[ { 'underline': sortKey === 'role' }]">Befattning</span>
                <SortChevron :sort-key="'role'" :sort-order="sortOrder" :current-sort-key="sortKey" />
            </th>
            <th class="text-[20px] p-2 text-left cursor-pointer" @click="sortBy('speciality')">
                <span :class="[ { 'underline': sortKey === 'speciality' }]">Specialistområde</span>
                <SortChevron :sort-key="'speciality'" :sort-order="sortOrder" :current-sort-key="sortKey" />
            </th>
            <th class="text-[20px] p-2 text-left cursor-pointer" @click="sortBy('region')">
                <span :class="[ { 'underline': sortKey === 'region' }]">Region</span>
                <SortChevron :sort-key="'region'" :sort-order="sortOrder" :current-sort-key="sortKey" />
            </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="person in sortedPersons" :key="person.id">
            <td class="text-[16px] p-2">{{ person.name }}</td>
            <td class="text-[16px] p-2">{{ person?.role?.name || '-' }}</td>
            <td class="text-[16px] p-2">{{ person?.speciality || '-' }}</td>
            <td class="text-[16px] p-2">{{ person?.region?.name || '-' }}</td>
        </tr>
        </tbody>
    </table>

    <!-- Fallback if no persons -->
    <h2 v-else class="text-3xl font-bold">
        Inga personer har öppnat brevet ännu.
    </h2>
</template>

<script>
import SortChevron from './SortChevron.vue'

export default {
    name: 'OpenedMailTable',
    components: { SortChevron },
    props: {
        persons: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            sortKey: null,
            sortOrder: 1, // 1 = ascending, -1 = descending
        }
    },
    computed: {
        sortedPersons() {
            // Make a copy so we don’t mutate the original array
            const sorted = [...this.persons]

            if (!this.sortKey) {
                this.sortKey = 'name'
            }

            sorted.sort((a, b) => {
                let aVal = ''
                let bVal = ''

                if (this.sortKey === 'name') {
                    aVal = a.name || ''
                    bVal = b.name || ''
                } else if (this.sortKey === 'role') {
                    aVal = a.role?.name || ''
                    bVal = b.role?.name || ''
                } else if (this.sortKey === 'speciality') {
                    aVal = a.speciality || ''
                    bVal = b.speciality || ''
                } else if (this.sortKey === 'region') {
                    aVal = a.region?.name || ''
                    bVal = b.region?.name || ''
                }

                if (aVal < bVal) return -1 * this.sortOrder
                if (aVal > bVal) return 1 * this.sortOrder
                return 0
            })

            return sorted
        },
    },
    methods: {
        sortBy(key) {
            // If clicked the same column, just toggle ascending/descending
            if (this.sortKey === key) {
                this.sortOrder *= -1
            } else {
                this.sortKey   = key
                this.sortOrder = 1
            }
        },
    },
}
</script>
